export default "__VITE_ASSET__BxdSL0xO__"